__turbopack_context__.v({
  "container": "TableOfContents-module-scss-module__zuxYFq__container",
  "control": "TableOfContents-module-scss-module__zuxYFq__control",
  "root": "TableOfContents-module-scss-module__zuxYFq__root",
});
